import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=b3927552&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3927552')) {
      api.createRecord('b3927552', component.options)
    } else {
      api.reload('b3927552', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=b3927552&", function () {
      api.rerender('b3927552', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2d2LGzIQamwa1/JS/offershelp.vue"
export default component.exports